import {createSlice,createAsyncThunk} from "@reduxjs/toolkit";


const themeSlice = createSlice({
    name:'theme',
    initialState:{
        mode:"dark",
        loading: false
    },
    reducers:{
        toggleTheme:(state)=>{
            state.mode =   state.mode === "light" ? "dark" : "light"
        }
    }
})

export const {toggleTheme} = themeSlice.actions;
export default themeSlice.reducer;